import { render, staticRenderFns } from "./AfterSaleOrderDetails.vue?vue&type=template&id=63ee1d58&scoped=true"
import script from "./AfterSaleOrderDetails.vue?vue&type=script&lang=js"
export * from "./AfterSaleOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./AfterSaleOrderDetails.vue?vue&type=style&index=0&id=63ee1d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee1d58",
  null
  
)

export default component.exports